import { grey } from '@mui/material/colors';

export default {
  contained: {
    color: grey['600']
  },
  sizeSmall: {
    fontSize: '0.705rem'
  }
};